/* this class will be handling all the db stores, schemas and db interactions */

import { NgModule } from '@angular/core';
import { LoggerService } from '@commoncore/services/logger.service';
import { SyncStorageHandler } from '@mainrepo/app/core/database/SyncStorageManager';
import { DBConfig, NgxIndexedDBModule, NgxIndexedDBService } from 'ngx-indexed-db';

// const TutorialstoreMainRepo = {
//   store: 'TutorialstoreMainRepo',
//   storeConfig: { keyPath: 'id', autoIncrement: true },
//   storeSchema: [
//     { name: 'userId', keypath: 'userId', options: { unique: false } },
//     { name: 'entTourMainRepoSeen', keypath: 'entTourMainRepoSeen', options: { unique: false } },
//     { name: 'entTourMainRepoNoadminSeen', keypath: 'entTourMainRepoNoadminSeen', options: { unique: false } },
//   ],
// };

// const TutorialstoreEntRepo ={
//   store: 'TutorialstoreEntRepo',
//   storeConfig: { keyPath: 'id', autoIncrement: true },
//   storeSchema: [
//     { name: 'userId', keypath: 'userId', options: { unique: false } },
//     { name: 'entTourEntRepoSeen', keypath: 'entTourEntRepoSeen', options: { unique: false } }
//   ],
// };

const UserStore = {
    store: 'user',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'name', keypath: 'name', options: { unique: false } },
      { name: 'email', keypath: 'email', options: { unique: false } },
    ],
  };
const allFiles =[
    // { name: 'id', keypath: 'id', options: { unique: true }, autoIncrement: true },
    { name: 'parentObjectKey', keypath: 'parentObjectKey', options: { unique: false } },
    { name: 'parentObjectType', keypath: 'parentObjectType', options: { unique: false } },
    { name: 'parentObjectId', keypath: 'parentObjectId', options: { unique: false } },
    { name: 'objectKey', keypath: 'objectKey', options: { unique: true } },
    { name: 'objectType', keypath: 'objectType', options: { unique: false } },
    { name: 'objectName', keypath: 'objectName', options: { unique: false } },
    { name: 'mimeType', keypath: 'mimeType', options: { unique: false } },
    { name: 'mimeSubType', keypath: 'mimeSubType', options: { unique: false } },
    { name: 'sizeInBytes', keypath: 'sizeInBytes', options: { unique: false } },
    { name: 'isHidden', keypath: 'isHidden', options: { unique: false } },
    { name: 'isLocked', keypath: 'isLocked', options: { unique: false } },
    { name: 'isReadonly', keypath: 'isReadonly', options: { unique: false } },
    { name: 'isRestricted', keypath: 'isRestricted', options: { unique: false } },
    { name: 'version', keypath: 'version', options: { unique: false } },
    { name: 'isFavorite', keypath: 'isFavorite', options: { unique: false } },
    { name: 'sourceName', keypath: 'sourceName', options: { unique: false } },
    { name: 'objectOwnerUserId', keypath: 'objectOwnerUserId', options: { unique: false } },
    { name: 'lastModifiedDate', keypath: 'lastModifiedDate', options: { unique: false } },
    { name: 'lastAccessedDate', keypath: 'lastAccessedDate', options: { unique: false } },
    { name: 'fileCreatedDate', keypath: 'fileCreatedDate', options: { unique: false } },
    { name: 'url', keypath: 'url', options: { unique: false } },
    { name: 'imageTranscodeUrl', keypath: 'imageTranscodeUrl', options: { unique: false } },
    { name: 'isBoardFile', keypath: 'isBoardFile', options: { unique: false } },
    { name: 'objectShareBy', keypath: 'objectShareBy', options: { unique: false } },
    { name: 'isPanoramic', keypath: 'isPanoramic', options: { unique: false } },
    { name: 'displayName', keypath: 'displayName', options: { unique: false } },
    { name: 'hash', keypath: 'hash', options: { unique: false } },
    { name: 'shareKey', keypath: 'shareKey', options: { unique: false } },
    { name: 'isInheritedShare', keypath: 'isInheritedShare', options: { unique: false } },
    { name: 'shareLink', keypath: 'shareLink', options: { unique: false } },
    { name: 'recipientsObjRights', keypath: 'recipientsObjRights', options: { unique: false } },
    { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
    { name: 'createdDate', keypath: 'createdDate', options: { unique: false } },
    { name: 'lastUpdatedDate', keypath: 'lastUpdatedDate', options: { unique: false } },
    { name: 'status', keypath: 'status', options: { unique: false } },
    { name: 'shareType', keypath: 'shareType', options: { unique: false } },
    { name: 'isShared', keypath: 'isShared', options: { unique: false } },      
    { name: 'playbackUrl', keypath: 'playbackUrl', options: { unique: false } },
    { name: 'documentUrl', keypath: 'documentUrl', options: { unique: false } }
  ];

const photoFilter = [
  {name: 'id', keypath: 'id', options: { unique: true } },
  { name: 'parentObjectKey', keypath: 'parentObjectKey', options: { unique: false } },
  { name: 'parentObjectType', keypath: 'parentObjectType', options: { unique: false } },
  { name: 'parentObjectId', keypath: 'parentObjectId', options: { unique: false } },
  { name: 'objectKey', keypath: 'objectKey', options: { unique: true } },
  { name: 'objectType', keypath: 'objectType', options: { unique: false } },
  { name: 'objectName', keypath: 'objectName', options: { unique: false } },
  { name: 'mimeType', keypath: 'mimeType', options: { unique: false } },
  { name: 'mimeSubType', keypath: 'mimeSubType', options: { unique: false } },
  { name: 'sizeInBytes', keypath: 'sizeInBytes', options: { unique: false } },
  { name: 'isHidden', keypath: 'isHidden', options: { unique: false } },
  { name: 'isLocked', keypath: 'isLocked', options: { unique: false } },
  { name: 'isReadonly', keypath: 'isReadonly', options: { unique: false } },
  { name: 'isRestricted', keypath: 'isRestricted', options: { unique: false } },
  { name: 'version', keypath: 'version', options: { unique: false } },
  { name: 'isFavorite', keypath: 'isFavorite', options: { unique: false } },
  { name: 'sourceName', keypath: 'sourceName', options: { unique: false } },
  { name: 'objectOwnerUserId', keypath: 'objectOwnerUserId', options: { unique: false } },
  { name: 'lastModifiedDate', keypath: 'lastModifiedDate', options: { unique: false } },
  { name: 'lastAccessedDate', keypath: 'lastAccessedDate', options: { unique: false } },
  { name: 'fileCreatedDate', keypath: 'fileCreatedDate', options: { unique: false } },
  { name: 'url', keypath: 'url', options: { unique: false } },
  { name: 'imageTranscodeUrl', keypath: 'imageTranscodeUrl', options: { unique: false } },
  { name: 'isBoardFile', keypath: 'isBoardFile', options: { unique: false } },
  { name: 'objectShareBy', keypath: 'objectShareBy', options: { unique: false } },
  { name: 'isPanoramic', keypath: 'isPanoramic', options: { unique: false } },
  { name: 'displayName', keypath: 'displayName', options: { unique: false } },
  { name: 'hash', keypath: 'hash', options: { unique: false } },
  { name: 'shareKey', keypath: 'shareKey', options: { unique: false } },
  { name: 'isInheritedShare', keypath: 'isInheritedShare', options: { unique: false } },
  { name: 'shareLink', keypath: 'shareLink', options: { unique: false } },
  { name: 'recipientsObjRights', keypath: 'recipientsObjRights', options: { unique: false } },
  { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
  { name: 'createdDate', keypath: 'createdDate', options: { unique: false } },
  { name: 'lastUpdatedDate', keypath: 'lastUpdatedDate', options: { unique: false } },
  { name: 'status', keypath: 'status', options: { unique: false } },
  { name: 'shareType', keypath: 'shareType', options: { unique: false } },
  { name: 'isShared', keypath: 'isShared', options: { unique: false } }
];

const videoFilter = [
  { name: 'parentObjectKey', keypath: 'parentObjectKey', options: { unique: false } },
  { name: 'parentObjectType', keypath: 'parentObjectType', options: { unique: false } },
  { name: 'parentObjectId', keypath: 'parentObjectId', options: { unique: false } },
  { name: 'objectKey', keypath: 'objectKey', options: { unique: true } },
  { name: 'objectType', keypath: 'objectType', options: { unique: false } },
  { name: 'objectName', keypath: 'objectName', options: { unique: false } },
  { name: 'mimeType', keypath: 'mimeType', options: { unique: false } },
  { name: 'mimeSubType', keypath: 'mimeSubType', options: { unique: false } },
  { name: 'sizeInBytes', keypath: 'sizeInBytes', options: { unique: false } },
  { name: 'isHidden', keypath: 'isHidden', options: { unique: false } },
  { name: 'isLocked', keypath: 'isLocked', options: { unique: false } },
  { name: 'isReadonly', keypath: 'isReadonly', options: { unique: false } },
  { name: 'isRestricted', keypath: 'isRestricted', options: { unique: false } },
  { name: 'version', keypath: 'version', options: { unique: false } },
  { name: 'isFavorite', keypath: 'isFavorite', options: { unique: false } },
  { name: 'sourceName', keypath: 'sourceName', options: { unique: false } },
  { name: 'objectOwnerUserId', keypath: 'objectOwnerUserId', options: { unique: false } },
  { name: 'lastModifiedDate', keypath: 'lastModifiedDate', options: { unique: false } },
  { name: 'lastAccessedDate', keypath: 'lastAccessedDate', options: { unique: false } },
  { name: 'fileCreatedDate', keypath: 'fileCreatedDate', options: { unique: false } },
  { name: 'url', keypath: 'url', options: { unique: false } },
  { name: 'imageTranscodeUrl', keypath: 'imageTranscodeUrl', options: { unique: false } },
  { name: 'isBoardFile', keypath: 'isBoardFile', options: { unique: false } },
  { name: 'objectShareBy', keypath: 'objectShareBy', options: { unique: false } },
  { name: 'isPanoramic', keypath: 'isPanoramic', options: { unique: false } },
  { name: 'displayName', keypath: 'displayName', options: { unique: false } },
  { name: 'hash', keypath: 'hash', options: { unique: false } },
  { name: 'shareKey', keypath: 'shareKey', options: { unique: false } },
  { name: 'isInheritedShare', keypath: 'isInheritedShare', options: { unique: false } },
  { name: 'shareLink', keypath: 'shareLink', options: { unique: false } },
  { name: 'recipientsObjRights', keypath: 'recipientsObjRights', options: { unique: false } },
  { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
  { name: 'createdDate', keypath: 'createdDate', options: { unique: false } },
  { name: 'lastUpdatedDate', keypath: 'lastUpdatedDate', options: { unique: false } },
  { name: 'status', keypath: 'status', options: { unique: false } },
  { name: 'shareType', keypath: 'shareType', options: { unique: false } },
  { name: 'isShared', keypath: 'isShared', options: { unique: false } }
];

const audioFilter = [
  { name: 'id', keypath: 'id', options: { unique: true } },
  { name: 'parentObjectKey', keypath: 'parentObjectKey', options: { unique: false } },
  { name: 'parentObjectType', keypath: 'parentObjectType', options: { unique: false } },
  { name: 'parentObjectId', keypath: 'parentObjectId', options: { unique: false } },
  { name: 'objectKey', keypath: 'objectKey', options: { unique: true } },
  { name: 'objectType', keypath: 'objectType', options: { unique: false } },
  { name: 'objectName', keypath: 'objectName', options: { unique: false } },
  { name: 'mimeType', keypath: 'mimeType', options: { unique: false } },
  { name: 'mimeSubType', keypath: 'mimeSubType', options: { unique: false } },
  { name: 'sizeInBytes', keypath: 'sizeInBytes', options: { unique: false } },
  { name: 'isHidden', keypath: 'isHidden', options: { unique: false } },
  { name: 'isLocked', keypath: 'isLocked', options: { unique: false } },
  { name: 'isReadonly', keypath: 'isReadonly', options: { unique: false } },
  { name: 'isRestricted', keypath: 'isRestricted', options: { unique: false } },
  { name: 'version', keypath: 'version', options: { unique: false } },
  { name: 'isFavorite', keypath: 'isFavorite', options: { unique: false } },
  { name: 'sourceName', keypath: 'sourceName', options: { unique: false } },
  { name: 'objectOwnerUserId', keypath: 'objectOwnerUserId', options: { unique: false } },
  { name: 'lastModifiedDate', keypath: 'lastModifiedDate', options: { unique: false } },
  { name: 'lastAccessedDate', keypath: 'lastAccessedDate', options: { unique: false } },
  { name: 'fileCreatedDate', keypath: 'fileCreatedDate', options: { unique: false } },
  { name: 'url', keypath: 'url', options: { unique: false } },
  { name: 'imageTranscodeUrl', keypath: 'imageTranscodeUrl', options: { unique: false } },
  { name: 'isBoardFile', keypath: 'isBoardFile', options: { unique: false } },
  { name: 'objectShareBy', keypath: 'objectShareBy', options: { unique: false } },
  { name: 'isPanoramic', keypath: 'isPanoramic', options: { unique: false } },
  { name: 'displayName', keypath: 'displayName', options: { unique: false } },
  { name: 'hash', keypath: 'hash', options: { unique: false } },
  { name: 'shareKey', keypath: 'shareKey', options: { unique: false } },
  { name: 'isInheritedShare', keypath: 'isInheritedShare', options: { unique: false } },
  { name: 'shareLink', keypath: 'shareLink', options: { unique: false } },
  { name: 'recipientsObjRights', keypath: 'recipientsObjRights', options: { unique: false } },
  { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
  { name: 'createdDate', keypath: 'createdDate', options: { unique: false } },
  { name: 'lastUpdatedDate', keypath: 'lastUpdatedDate', options: { unique: false } },
  { name: 'status', keypath: 'status', options: { unique: false } },
  { name: 'shareType', keypath: 'shareType', options: { unique: false } },
  { name: 'isShared', keypath: 'isShared', options: { unique: false } },
  { name: 'width', keypath: 'width', options: { unique: false } },
  { name: 'playbackUrl', keypath: 'playbackUrl', options: { unique: false } }
];

const docFilter = [
  // { name: 'id', keypath: 'id', options: { unique: true } },
   { name: 'parentObjectKey', keypath: 'parentObjectKey', options: { unique: false } },
   { name: 'parentObjectType', keypath: 'parentObjectType', options: { unique: false } },
   { name: 'parentObjectId', keypath: 'parentObjectId', options: { unique: false } },
   { name: 'objectKey', keypath: 'objectKey', options: { unique: true } },
   { name: 'objectType', keypath: 'objectType', options: { unique: false } },
   { name: 'objectName', keypath: 'objectName', options: { unique: false } },
   { name: 'mimeType', keypath: 'mimeType', options: { unique: false } },
   { name: 'mimeSubType', keypath: 'mimeSubType', options: { unique: false } },
   { name: 'sizeInBytes', keypath: 'sizeInBytes', options: { unique: false } },
   { name: 'isHidden', keypath: 'isHidden', options: { unique: false } },
   { name: 'isLocked', keypath: 'isLocked', options: { unique: false } },
   { name: 'isReadonly', keypath: 'isReadonly', options: { unique: false } },
   { name: 'isRestricted', keypath: 'isRestricted', options: { unique: false } },
   { name: 'version', keypath: 'version', options: { unique: false } },
   { name: 'isFavorite', keypath: 'isFavorite', options: { unique: false } },
   { name: 'sourceName', keypath: 'sourceName', options: { unique: false } },
   { name: 'objectOwnerUserId', keypath: 'objectOwnerUserId', options: { unique: false } },
   { name: 'lastModifiedDate', keypath: 'lastModifiedDate', options: { unique: false } },
   { name: 'lastAccessedDate', keypath: 'lastAccessedDate', options: { unique: false } },
   { name: 'fileCreatedDate', keypath: 'fileCreatedDate', options: { unique: false } },
   { name: 'url', keypath: 'url', options: { unique: false } },
   { name: 'imageTranscodeUrl', keypath: 'imageTranscodeUrl', options: { unique: false } },
   { name: 'isBoardFile', keypath: 'isBoardFile', options: { unique: false } },
   { name: 'objectShareBy', keypath: 'objectShareBy', options: { unique: false } },
   { name: 'isPanoramic', keypath: 'isPanoramic', options: { unique: false } },
   { name: 'displayName', keypath: 'displayName', options: { unique: false } },
   { name: 'hash', keypath: 'hash', options: { unique: false } },
   { name: 'shareKey', keypath: 'shareKey', options: { unique: false } },
   { name: 'isInheritedShare', keypath: 'isInheritedShare', options: { unique: false } },
   { name: 'shareLink', keypath: 'shareLink', options: { unique: false } },
   { name: 'recipientsObjRights', keypath: 'recipientsObjRights', options: { unique: false } },
   { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
   { name: 'createdDate', keypath: 'createdDate', options: { unique: false } },
   { name: 'lastUpdatedDate', keypath: 'lastUpdatedDate', options: { unique: false } },
   { name: 'status', keypath: 'status', options: { unique: false } },
   { name: 'shareType', keypath: 'shareType', options: { unique: false } },
   { name: 'isShared', keypath: 'isShared', options: { unique: false } },
   { name: 'documentUrl', keypath: 'documentUrl', options: { unique: false } }
 ];

const FileMetadata = {
  store: 'files',
  storeConfig: { keyPath: 'objectKey', autoIncrement: false },
  storeSchema: [
    // { name: 'id', keypath: 'id', options: { unique: true }, autoIncrement: true },
    { name: 'parentObjectKey', keypath: 'parentObjectKey', options: { unique: false } },
    { name: 'parentObjectType', keypath: 'parentObjectType', options: { unique: false } },
    { name: 'parentObjectId', keypath: 'parentObjectId', options: { unique: false } },
    { name: 'objectKey', keypath: 'objectKey', options: { unique: true } },
    { name: 'objectType', keypath: 'objectType', options: { unique: false } },
    { name: 'objectName', keypath: 'objectName', options: { unique: false } },
    { name: 'mimeType', keypath: 'mimeType', options: { unique: false } },
    { name: 'mimeSubType', keypath: 'mimeSubType', options: { unique: false } },
    { name: 'sizeInBytes', keypath: 'sizeInBytes', options: { unique: false } },
    { name: 'isHidden', keypath: 'isHidden', options: { unique: false } },
    { name: 'isLocked', keypath: 'isLocked', options: { unique: false } },
    { name: 'isReadonly', keypath: 'isReadonly', options: { unique: false } },
    { name: 'isRestricted', keypath: 'isRestricted', options: { unique: false } },
    { name: 'version', keypath: 'version', options: { unique: false } },
    { name: 'isFavorite', keypath: 'isFavorite', options: { unique: false } },
    { name: 'sourceName', keypath: 'sourceName', options: { unique: false } },
    { name: 'objectOwnerUserId', keypath: 'objectOwnerUserId', options: { unique: false } },
    { name: 'lastModifiedDate', keypath: 'lastModifiedDate', options: { unique: false } },
    { name: 'lastAccessedDate', keypath: 'lastAccessedDate', options: { unique: false } },
    { name: 'fileCreatedDate', keypath: 'fileCreatedDate', options: { unique: false } },
    { name: 'url', keypath: 'url', options: { unique: false } },
    
    { name: 'isBoardFile', keypath: 'isBoardFile', options: { unique: false } },
    { name: 'objectShareBy', keypath: 'objectShareBy', options: { unique: false } },
    { name: 'isPanoramic', keypath: 'isPanoramic', options: { unique: false } },
    { name: 'displayName', keypath: 'displayName', options: { unique: false } },
    { name: 'hash', keypath: 'hash', options: { unique: false } },
    { name: 'shareKey', keypath: 'shareKey', options: { unique: false } },
    { name: 'isInheritedShare', keypath: 'isInheritedShare', options: { unique: false } },
    { name: 'shareLink', keypath: 'shareLink', options: { unique: false } },
    { name: 'recipientsObjRights', keypath: 'recipientsObjRights', options: { unique: false } },
    { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
    { name: 'createdDate', keypath: 'createdDate', options: { unique: false } },
    { name: 'lastUpdatedDate', keypath: 'lastUpdatedDate', options: { unique: false } },
    { name: 'status', keypath: 'status', options: { unique: false } },
    { name: 'shareType', keypath: 'shareType', options: { unique: false } },
    { name: 'isShared', keypath: 'isShared', options: { unique: false } },      
    { name: 'playbackUrl', keypath: 'playbackUrl', options: { unique: false } },
    { name: 'documentUrl', keypath: 'documentUrl', options: { unique: false } },

    { name: 'imageTranscodeUrl', keypath: 'imageTranscodeUrl', options: { unique: false } },
    
  ],
};

const FolderMetadata = {
  store: 'folder',
  storeConfig: { keyPath: 'objectKey', autoIncrement: false },
  storeSchema: [
    // { name: 'id', keypath: 'id', options: { unique: true }, autoIncrement: true },
    { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
    { name: 'createdDate', keypath: 'createdDate', options: { unique: false } },
    { name: 'fileCreatedDate', keypath: 'fileCreatedDate', options: { unique: false } },
    { name: 'isFavorite', keypath: 'isFavorite', options: { unique: false } },
    { name: 'isHidden', keypath: 'isHidden', options: { unique: false } },
    { name: 'isInheritedShare', keypath: 'isInheritedShare', options: { unique: false } },
    { name: 'isLocked', keypath: 'isLocked', options: { unique: false } },
    { name: 'isReadonly', keypath: 'isReadonly', options: { unique: false } },
    { name: 'isRestricted', keypath: 'isRestricted', options: { unique: false } },
    { name: 'lastAccessedDate', keypath: 'lastAccessedDate', options: { unique: false } },
    { name: 'lastModifiedDate', keypath: 'lastModifiedDate', options: { unique: false } },
    { name: 'lastUpdatedDate', keypath: 'lastUpdatedDate', options: { unique: false } },
    { name: 'objectKey', keypath: 'objectKey', options: { unique: true } },
    { name: 'objectName', keypath: 'objectName', options: { unique: false } },
    { name: 'objectOwnerUserId', keypath: 'objectOwnerUserId', options: { unique: false } },
    { name: 'objectType', keypath: 'objectType', options: { unique: false } },
    { name: 'parentObjectId', keypath: 'parentObjectId', options: { unique: false } },
    { name: 'parentObjectKey', keypath: 'parentObjectKey', options: { unique: false } },
    { name: 'parentObjectType', keypath: 'parentObjectType', options: { unique: false } },
    { name: 'sourceName', keypath: 'sourceName', options: { unique: false } },
    { name: 'status', keypath: 'status', options: { unique: false } },
    { name: 'version', keypath: 'version', options: { unique: false } },
  ],
};

const NextLink = {
  store: 'NextLink',
    storeConfig: { keyPath: 'storeName', autoIncrement: true },
    storeSchema: [
      { name: 'storeName', keypath: 'storeName', options: { unique: true } },
      { name: 'nextLink', keypath: 'nextLink', options: { unique: false } },
    ],
};

const AllFilesMetadata_List_Name_Asc = {
  store: 'AllFilesMetadata_List_Name_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles,
};

const AllFilesMetadata_List_Name_Desc = {
  store: 'AllFilesMetadata_List_Name_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles
  };

const AllFilesMetadata_List_Date_Asc = {
  store: 'AllFilesMetadata_List_Date_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles
  };

const AllFilesMetadata_List_Date_Desc = {
  store: 'AllFilesMetadata_List_Date_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles
  };

const AllFilesMetadata_List_Size_Asc = {
  store: 'AllFilesMetadata_List_Size_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles
  };

const AllFilesMetadata_List_Size_Desc = {
  store: 'AllFilesMetadata_List_Size_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles
  };

const AllFilesMetadata_List_Type_Asc = {
  store: 'AllFilesMetadata_List_Type_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles
  };

const AllFilesMetadata_List_Type_Desc = {
  store: 'AllFilesMetadata_List_Type_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles
  };

const AllFilesMetadata_Grid_Name_Asc = {
  store: 'AllFilesMetadata_Grid_Name_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles
  };

const AllFilesMetadata_Grid_Date_Desc = {
  store: 'AllFilesMetadata_Grid_Date_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles
  };

const AllFiles_FolderMetadata_Name_Asc = {
  store: 'AllFiles_FolderMetadata_Name_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles
  };

const AllFiles_FolderMetadata_Date_Desc = {
  store: 'AllFiles_FolderMetadata_Date_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles,
};

const PhotosMetadata_ObjectName = {
  store: 'PhotosMetadata_ObjectName',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: photoFilter,
};

const PhotosMetadata_FileCreatedDate = {
  store: 'PhotosMetadata_FileCreatedDate',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: photoFilter
  };

  const PhotosMetadata_CreatedDate = {
    store: 'PhotosMetadata_CreatedDate',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: photoFilter
    };

const VideosMetadata_ObjectName = {
  store: 'VideosMetadata_ObjectName',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: videoFilter};

const VideosMetadata_FileCreatedDate = {
  store: 'VideosMetadata_FileCreatedDate',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: videoFilter
  };

  const VideosMetadata_CreatedDate = {
    store: 'VideosMetadata_CreatedDate',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: videoFilter
  };

const MyAlbumsList = {
  store: 'MyAlbumsList',
    storeConfig: { keyPath: 'boardKey', autoIncrement: false },
    storeSchema: [
      // { name: 'id', keypath: 'id', options: { unique: true }, autoIncrement: true },
      { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
      { name: 'createdDate', keypath: 'createdDate', options: { unique: false } },
      { name: 'lastUpdatedDate', keypath: 'lastUpdatedDate', options: { unique: false } },
      { name: 'boardKey', keypath: 'boardKey', options: { unique: true } },
      { name: 'boardName', keypath: 'boardName', options: { unique: false } },
      { name: 'boardType', keypath: 'boardType', options: { unique: false } },
      { name: 'status', keypath: 'status', options: { unique: false } },
      { name: 'coverPicMimeType', keypath: 'coverPicMimeType', options: { unique: false } },
      { name: 'boardCoverPicObjectKey', keypath: 'boardCoverPicObjectKey', options: { unique: false } },
      { name: 'isCoverPicSetByUser', keypath: 'isCoverPicSetByUser', options: { unique: false } },
      { name: 'boardCoverPic', keypath: 'boardCoverPic', options: { unique: false } },
      { name: 'usersCount', keypath: 'usersCount', options: { unique: false } },
      { name: 'filesCount', keypath: 'filesCount', options: { unique: false } },
      { name: 'audioCount', keypath: 'audioCount', options: { unique: false } },
      { name: 'videoCount', keypath: 'videoCount', options: { unique: false } },
      { name: 'imageCount', keypath: 'imageCount', options: { unique: false } },
      { name: 'documentCount', keypath: 'documentCount', options: { unique: false } },
      { name: 'othersCount', keypath: 'othersCount', options: { unique: false } },
      { name: 'commentsCount', keypath: 'commentsCount', options: { unique: false } },
      { name: 'boardDescription', keypath: 'boardDescription', options: { unique: false } },
      { name: 'lastModifiedDate', keypath: 'lastModifiedDate', options: { unique: false } },
      { name: 'coverPicStorageId', keypath: 'coverPicStorageId', options: { unique: false } },
      { name: 'owner', keypath: 'owner', options: { unique: false } },
      { name: 'isShareAlbum', keypath: 'isShareAlbum', options: { unique: false } },
      // { name: 'ownerFirstName', keypath: 'ownerFirstName', options: { unique: false } },
      // { name: 'ownerLastName', keypath: 'ownerLastName', options: { unique: false } },
      // { name: 'ownerProfilePic', keypath: 'ownerProfilePic', options: { unique: false } },
      // { name: 'ownerUserId', keypath: 'ownerUserId', options: { unique: false } },
      // { name: 'ownerPicStorageId', keypath: 'ownerPicStorageId', options: { unique: false } },
      { name: 'userBoardRelation', keypath: 'userBoardRelation', options: { unique: false } },
      //{ name: 'memberType', keypath: 'memberType', options: { unique: false } }
    ],
};

const SharedAlbumsList = {
  store: 'SharedAlbumsList',
    storeConfig: { keyPath: 'boardKey', autoIncrement: false },
    storeSchema: [
      // { name: 'id', keypath: 'id', options: { unique: true }, autoIncrement: true },
      { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
      { name: 'createdDate', keypath: 'createdDate', options: { unique: false } },
      { name: 'lastUpdatedDate', keypath: 'lastUpdatedDate', options: { unique: false } },
      { name: 'boardKey', keypath: 'boardKey', options: { unique: true } },
      { name: 'boardName', keypath: 'boardName', options: { unique: false } },
      { name: 'boardType', keypath: 'boardType', options: { unique: false } },
      { name: 'status', keypath: 'status', options: { unique: false } },
      { name: 'coverPicMimeType', keypath: 'coverPicMimeType', options: { unique: false } },
      { name: 'boardCoverPicObjectKey', keypath: 'boardCoverPicObjectKey', options: { unique: false } },
      { name: 'isCoverPicSetByUser', keypath: 'isCoverPicSetByUser', options: { unique: false } },
      { name: 'boardCoverPic', keypath: 'boardCoverPic', options: { unique: false } },
      { name: 'usersCount', keypath: 'usersCount', options: { unique: false } },
      { name: 'filesCount', keypath: 'filesCount', options: { unique: false } },
      { name: 'audioCount', keypath: 'audioCount', options: { unique: false } },
      { name: 'videoCount', keypath: 'videoCount', options: { unique: false } },
      { name: 'imageCount', keypath: 'imageCount', options: { unique: false } },
      { name: 'documentCount', keypath: 'documentCount', options: { unique: false } },
      { name: 'othersCount', keypath: 'othersCount', options: { unique: false } },
      { name: 'commentsCount', keypath: 'commentsCount', options: { unique: false } },
      { name: 'boardDescription', keypath: 'boardDescription', options: { unique: false } },
      { name: 'lastModifiedDate', keypath: 'lastModifiedDate', options: { unique: false } },
      { name: 'coverPicStorageId', keypath: 'coverPicStorageId', options: { unique: false } },
      { name: 'owner', keypath: 'owner', options: { unique: false } },
      { name: 'isShareAlbum', keypath: 'isShareAlbum', options: { unique: false } },
      // { name: 'ownerFirstName', keypath: 'ownerFirstName', options: { unique: false } },
      // { name: 'ownerLastName', keypath: 'ownerLastName', options: { unique: false } },
      // { name: 'ownerProfilePic', keypath: 'ownerProfilePic', options: { unique: false } },
      // { name: 'ownerUserId', keypath: 'ownerUserId', options: { unique: false } },
      // { name: 'ownerPicStorageId', keypath: 'ownerPicStorageId', options: { unique: false } },
      { name: 'userBoardRelation', keypath: 'userBoardRelation', options: { unique: false } },
      //{ name: 'memberType', keypath: 'memberType', options: { unique: false } }
    ],
};

const AudiosMetadata_FileCreatedDate_Asc = {
  store: 'AudiosMetadata_FileCreatedDate_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: audioFilter
  };

const AudiosMetadata_FileCreatedDate_Desc = {
  store: 'AudiosMetadata_FileCreatedDate_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: audioFilter
  };

const AudiosMetadata_CreatedDate_Asc = {
  store: 'AudiosMetadata_CreatedDate_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: audioFilter
  };

const AudiosMetadata_CreatedDate_Desc = {
  store: 'AudiosMetadata_CreatedDate_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: audioFilter
  };

const AudiosMetadata_Name_Asc = {
  store: 'AudiosMetadata_Name_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: audioFilter
  };

const AudiosMetadata_Name_Desc = {
  store: 'AudiosMetadata_Name_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: audioFilter
  };




const DocumentMetadata_FileCreatedDate_Asc = {
  store: 'DocumentMetadata_FileCreatedDate_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: docFilter};

const DocumentMetadata_FileCreatedDate_Desc = {
  store: 'DocumentMetadata_FileCreatedDate_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: docFilter
  };

const DocumentMetadata_CreatedDate_Asc = {
  store: 'DocumentMetadata_CreatedDate_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: docFilter};

const DocumentMetadata_CreatedDate_Desc = {
  store: 'DocumentMetadata_CreatedDate_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: docFilter
  };

const DocumentMetadata_Name_Asc = {
  store: 'DocumentMetadata_Name_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: docFilter
  };

const DocumentMetadata_Name_Desc = {
  store: 'DocumentMetadata_Name_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: docFilter
  };
const DocumentMetadata_Size_Asc = {
  store: 'DocumentMetadata_Size_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: docFilter
  };

const DocumentMetadata_Size_Desc = {
  store: 'DocumentMetadata_Size_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: docFilter
  };

const DocumentMetadata_Type_Asc = {
  store: 'DocumentMetadata_Type_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: docFilter
  };

const DocumentMetadata_Type_Desc = {
  store: 'DocumentMetadata_Type_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: docFilter
  };

const RecentFilesMetadata = {
  store: 'RecentFilesMetadata',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'id', keypath: 'id', options: { unique: true }, autoIncrement: true },
      { name: 'parentObjectKey', keypath: 'parentObjectKey', options: { unique: false } },
      { name: 'parentObjectType', keypath: 'parentObjectType', options: { unique: false } },
      { name: 'parentObjectId', keypath: 'parentObjectId', options: { unique: false } },
      { name: 'objectKey', keypath: 'objectKey', options: { unique: true } },
      { name: 'objectType', keypath: 'objectType', options: { unique: false } },
      { name: 'objectName', keypath: 'objectName', options: { unique: false } },
      { name: 'mimeType', keypath: 'mimeType', options: { unique: false } },
      { name: 'mimeSubType', keypath: 'mimeSubType', options: { unique: false } },
      { name: 'sizeInBytes', keypath: 'sizeInBytes', options: { unique: false } },
      { name: 'isHidden', keypath: 'isHidden', options: { unique: false } },
      { name: 'isLocked', keypath: 'isLocked', options: { unique: false } },
      { name: 'isReadonly', keypath: 'isReadonly', options: { unique: false } },
      { name: 'isRestricted', keypath: 'isRestricted', options: { unique: false } },
      { name: 'version', keypath: 'version', options: { unique: false } },
      { name: 'isFavorite', keypath: 'isFavorite', options: { unique: false } },
      { name: 'sourceName', keypath: 'sourceName', options: { unique: false } },
      { name: 'objectOwnerUserId', keypath: 'objectOwnerUserId', options: { unique: false } },
      { name: 'lastModifiedDate', keypath: 'lastModifiedDate', options: { unique: false } },
      { name: 'lastAccessedDate', keypath: 'lastAccessedDate', options: { unique: false } },
      { name: 'fileCreatedDate', keypath: 'fileCreatedDate', options: { unique: false } },
      { name: 'url', keypath: 'url', options: { unique: false } },
      { name: 'imageTranscodeUrl', keypath: 'imageTranscodeUrl', options: { unique: false } },
      { name: 'isBoardFile', keypath: 'isBoardFile', options: { unique: false } },
      { name: 'objectShareBy', keypath: 'objectShareBy', options: { unique: false } },
      { name: 'isPanoramic', keypath: 'isPanoramic', options: { unique: false } },
      { name: 'displayName', keypath: 'displayName', options: { unique: false } },
      { name: 'hash', keypath: 'hash', options: { unique: false } },
      { name: 'shareKey', keypath: 'shareKey', options: { unique: false } },
      { name: 'isInheritedShare', keypath: 'isInheritedShare', options: { unique: false } },
      { name: 'shareLink', keypath: 'shareLink', options: { unique: false } },
      { name: 'recipientsObjRights', keypath: 'recipientsObjRights', options: { unique: false } },
      { name: 'createdBy', keypath: 'createdBy', options: { unique: false } },
      { name: 'createdDate', keypath: 'createdDate', options: { unique: false } },
      { name: 'lastUpdatedDate', keypath: 'lastUpdatedDate', options: { unique: false } },
      { name: 'status', keypath: 'status', options: { unique: false } },
      { name: 'shareType', keypath: 'shareType', options: { unique: false } },
      { name: 'isShared', keypath: 'isShared', options: { unique: false } },
      { name: 'playbackUrl', keypath: 'playbackUrl', options: { unique: false } },
      { name: 'documentUrl', keypath: 'documentUrl', options: { unique: false } }
    ],
  };


const ContactsStore_Asc = {
  store: 'ContactsStore_Asc',
  storeConfig: { keyPath: 'id', autoIncrement: true },
  storeSchema: [],
}

const ContactsStore_Dsc = {
  store: 'ContactsStore_Dsc',
  storeConfig: { keyPath: 'id', autoIncrement: true },
  storeSchema: [],
}

const PhotosMetadata_ObjectName_Desc = {
  store: 'PhotosMetadata_ObjectName_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: photoFilter,
};

const PhotosMetadata_FileCreatedDate_Asc = {
  store: 'PhotosMetadata_FileCreatedDate_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: photoFilter,
};

const PhotosMetadata_CreatedDate_Asc = {
  store: 'PhotosMetadata_CreatedDate_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: photoFilter,
};

const VideosMetadata_ObjectName_Desc = {
  store: 'VideosMetadata_ObjectName_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: videoFilter,
};

const VideosMetadata_FileCreatedDate_Asc = {
  store: 'VideosMetadata_FileCreatedDate_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: videoFilter,
};

const VideosMetadata_CreatedDate_Asc = {
  store: 'VideosMetadata_CreatedDate_Asc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: videoFilter,
};

const AllFiles_FolderMetadata_Name_Desc={
  store: 'AllFiles_FolderMetadata_Name_Desc',
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: allFiles,
};
const AllFiles_FolderMetadata_Date_Asc = {
      store: 'AllFiles_FolderMetadata_Date_Asc',
        storeConfig: { keyPath: 'id', autoIncrement: true },
        storeSchema: allFiles,
    };
    const AllFiles_FolderMetadata_CreatedDate_Asc={
      store: 'AllFiles_FolderMetadata_CreatedDate_Asc',
        storeConfig: { keyPath: 'id', autoIncrement: true },
        storeSchema: allFiles,
    };
    const AllFiles_FolderMetadata_CreatedDate_Desc={
      store: 'AllFiles_FolderMetadata_CreatedDate_Desc',
        storeConfig: { keyPath: 'id', autoIncrement: true },
        storeSchema: allFiles,
    };
    const AllFilesMetadata_Grid_Name_Desc = {
      store: 'AllFilesMetadata_Grid_Name_Desc',
        storeConfig: { keyPath: 'id', autoIncrement: true },
        storeSchema: allFiles,
    };
    const AllFilesMetadata_Grid_Date_Asc = {
      store: 'AllFilesMetadata_Grid_Date_Asc',
        storeConfig: { keyPath: 'id', autoIncrement: true },
        storeSchema: allFiles,
    };
    const AllFilesMetadata_Grid_CreatedDate_Asc = {
      store: 'AllFilesMetadata_Grid_CreatedDate_Asc',
        storeConfig: { keyPath: 'id', autoIncrement: true },
        storeSchema: allFiles,
    };
    const AllFilesMetadata_Grid_CreatedDate_Desc = {
      store: 'AllFilesMetadata_Grid_CreatedDate_Desc',
        storeConfig: { keyPath: 'id', autoIncrement: true },
        storeSchema: allFiles,
    };

const dbConfig: DBConfig  = {
  name: 'JioCloudWebDB',
  version: 38,
  objectStoresMeta: [
    AllFilesMetadata_List_Name_Asc,
    AllFilesMetadata_List_Name_Desc,
    AllFilesMetadata_List_Date_Asc,
    AllFilesMetadata_List_Date_Desc,
    AllFilesMetadata_List_Size_Asc,
    AllFilesMetadata_List_Size_Desc,
    AllFilesMetadata_List_Type_Asc,
    AllFilesMetadata_List_Type_Desc,
    AllFilesMetadata_Grid_Name_Asc,
    AllFilesMetadata_Grid_Date_Desc,
    AllFiles_FolderMetadata_Name_Asc,
    AllFiles_FolderMetadata_Date_Desc,
    PhotosMetadata_ObjectName,
    PhotosMetadata_FileCreatedDate,
    PhotosMetadata_CreatedDate,
    VideosMetadata_ObjectName,
    VideosMetadata_FileCreatedDate,
    VideosMetadata_CreatedDate,
    NextLink,
    ContactsStore_Asc,
    ContactsStore_Dsc,
    MyAlbumsList,
    SharedAlbumsList,
    AudiosMetadata_FileCreatedDate_Asc,
    AudiosMetadata_FileCreatedDate_Desc,
    AudiosMetadata_CreatedDate_Asc,
    AudiosMetadata_CreatedDate_Desc,
    AudiosMetadata_Name_Asc,
    AudiosMetadata_Name_Desc,
    DocumentMetadata_FileCreatedDate_Asc,
    DocumentMetadata_FileCreatedDate_Desc,
    DocumentMetadata_CreatedDate_Asc,
    DocumentMetadata_CreatedDate_Desc,
    DocumentMetadata_Name_Asc,
    DocumentMetadata_Name_Desc,
    DocumentMetadata_Size_Asc,
    DocumentMetadata_Size_Desc,
    DocumentMetadata_Type_Asc,
    DocumentMetadata_Type_Desc,
    RecentFilesMetadata,


    PhotosMetadata_ObjectName_Desc,
    PhotosMetadata_FileCreatedDate_Asc,
    PhotosMetadata_CreatedDate_Asc,

    VideosMetadata_ObjectName_Desc,
    VideosMetadata_FileCreatedDate_Asc,
    VideosMetadata_CreatedDate_Asc,

    AllFiles_FolderMetadata_Name_Desc,
    AllFiles_FolderMetadata_Date_Asc,
    AllFiles_FolderMetadata_CreatedDate_Asc,
    AllFiles_FolderMetadata_CreatedDate_Desc,
    AllFilesMetadata_Grid_Name_Desc,
    AllFilesMetadata_Grid_Date_Asc,
    AllFilesMetadata_Grid_CreatedDate_Asc,  
    AllFilesMetadata_Grid_CreatedDate_Desc,
    
  ]
};

//UserStore, FileMetadata,FolderMetadata,
@NgModule({
  imports: [
    NgxIndexedDBModule.forRoot(dbConfig),
  ],
  providers: [
  ],
  declarations: [],
})

export class IndexedDBModule {
    db: any;
    public static singleInstance: any;
    public syncStorageManager: SyncStorageHandler;
    static indexedDBModuleRef: any;

    
    constructor(dbService: NgxIndexedDBService,public loggerService:LoggerService) {
      this.db = dbService;
      this.syncStorageManager = new SyncStorageHandler();
    }

    clearAllStore(){
      this.clearStore('AllFilesMetadata_Grid_Name_Asc')
      this.clearStore('AllFilesMetadata_Grid_Date_Desc')
      this.clearStore('AllFiles_FolderMetadata_Name_Asc')
      this.clearStore('AllFiles_FolderMetadata_Date_Desc')
      this.clearStore('AllFilesMetadata_List_Name_Asc')
      this.clearStore('AllFilesMetadata_List_Name_Desc')
      this.clearStore('AllFilesMetadata_List_Date_Asc')
      this.clearStore('AllFilesMetadata_List_Date_Desc')
      this.clearStore('AllFilesMetadata_List_Size_Asc')
      this.clearStore('AllFilesMetadata_List_Size_Desc')
      this.clearStore('AllFilesMetadata_List_Type_Asc')
      this.clearStore('AllFilesMetadata_List_Type_Desc')

      

      this.clearStore('NextLink');
      
      this.clearStore('AudiosMetadata_Name_Asc')
      this.clearStore('AudiosMetadata_Name_Desc')
      this.clearStore('DocumentMetadata_FileCreatedDate_Asc')
      this.clearStore('DocumentMetadata_FileCreatedDate_Desc')
      this.clearStore('DocumentMetadata_CreatedDate_Asc')
      this.clearStore('DocumentMetadata_CreatedDate_Desc')
      this.clearStore('PhotosMetadata_ObjectName');
      this.clearStore('PhotosMetadata_FileCreatedDate');
      this.clearStore('PhotosMetadata_CreatedDate');
      this.clearStore('VideosMetadata_ObjectName');
      this.clearStore('VideosMetadata_FileCreatedDate');
      this.clearStore('VideosMetadata_CreatedDate');
      this.clearStore('ContactsStore_Asc');
      this.clearStore('ContactsStore_Dsc');
      this.clearStore('MyAlbumsList');
      this.clearStore('SharedAlbumsList');

      this.clearStore('DocumentMetadata_Name_Asc')
      this.clearStore('DocumentMetadata_Name_Desc')
      this.clearStore('DocumentMetadata_Size_Asc')
      this.clearStore('DocumentMetadata_Size_Desc')
      this.clearStore('DocumentMetadata_Type_Asc')
      this.clearStore('DocumentMetadata_Type_Desc')
      this.clearStore('AudiosMetadata_FileCreatedDate_Asc')
      this.clearStore('AudiosMetadata_FileCreatedDate_Desc')
      this.clearStore('AudiosMetadata_CreatedDate_Asc')
      this.clearStore('AudiosMetadata_CreatedDate_Desc')
      this.clearStore('RecentFilesMetadata')

      this.clearStore('PhotosMetadata_ObjectName_Desc');
      this.clearStore('PhotosMetadata_FileCreatedDate_Asc');
      this.clearStore('PhotosMetadata_CreatedDate_Asc');
      this.clearStore('VideosMetadata_ObjectName_Desc');
      this.clearStore('VideosMetadata_FileCreatedDate_Asc');
      this.clearStore('VideosMetadata_CreatedDate_Asc');

      this.clearStore('AllFiles_FolderMetadata_Name_Desc');
      this.clearStore('AllFiles_FolderMetadata_Date_Asc');
      this.clearStore('AllFiles_FolderMetadata_CreatedDate_Asc');
      this.clearStore('AllFiles_FolderMetadata_CreatedDate_Desc');
      this.clearStore('AllFilesMetadata_Grid_Name_Desc');
      this.clearStore('AllFilesMetadata_Grid_Date_Asc');
      this.clearStore('AllFilesMetadata_Grid_CreatedDate_Asc');
      this.clearStore('AllFilesMetadata_Grid_CreatedDate_Desc');
      
    }

    public static getInstance(globalService): IndexedDBModule {
      if (this.singleInstance == null) {
        this.singleInstance = new IndexedDBModule(globalService.getDbService(), globalService.getLoggerServiceRef());
        return this.singleInstance;
      } else {
        return this.singleInstance;
      }
    }

    public bulkAdd (storeName,bulkData):any {
      var self = this;
      return new Promise((resolve, reject) => {
        self.db.bulkAdd(storeName,bulkData).subscribe((result) => {
          if(result.length > 0) {
            resolve(true);
          } else {
            resolve(false);
          }
        }, error => {
          resolve(false);
        });
      })
    }

    public add (storeName,data) {
      return new Promise((resolve, reject) => {
        this.db.add(storeName,data).subscribe((result) => {
          if(result.length > 0) {
            resolve(true);
          } else {
            resolve(false);
          }
        }, error => {
          resolve(false);
        });
      })
    }

    public update (storeName, data) {
      return new Promise((resolve, reject) => {
        this.db.update(storeName,data).subscribe((result) => {
          if(result.length > 0) {
            resolve(true);
          } else {
            resolve(false);
          }
        }, error => {
          resolve(false);
        });
      })
      
    }

    async getAllData(storeName,type) {
      return new Promise((resolve, reject) => {
        let cTime= new Date().getTime();
        this.db.getAll(storeName, 'objectKey').subscribe((result) => {
          if(result.length != 0) {
            resolve(result);
          } else {
            resolve(false);
          }
        }, error => {
          resolve(false);
        });
      });
    }

    async getByKey (storeName, key) {
      return new Promise((resolve, reject) => {     
        this.db.getByKey(storeName, key).subscribe((result) => {
          resolve(result);
        }, error => {
          resolve(error);
        });
      });

      //this.db.getByKey(storeName, key).subscribe((response) => {
       // response.objectName = value
       // try{
         // this.db.updateByKey(storeName,response ).subscribe((item) => {//, IDBKeyRange.only(key)
          //})
        //}catch(e){
          //console.log(e)
       // }
       
     // });

    
      
      // this.db.updateByKey(storeName, {
        
	    //   "parentObjectKey":"6B0C29B024083BBFE0531D0B16AC04B9","parentObjectType":"FU","parentObjectId":1200001047863,"objectKey":"04cd1bd6476d42af86e020ecf699369f","objectType":"FE","objectName":"BOARDS44  Release22 notes244.docx","parentObjectName":"Root Folder","mimeType":"application","mimeSubType":"vnd.openxmlformats-officedocument.wordprocessingml.document","sizeInBytes":17259,"isHidden":false,"isLocked":false,"isReadonly":false,"isRestricted":false,"version":1,"isPinned":false,"isFavorite":false,"sourceName":"uploadApi","objectOwnerUserId":"cdbd05c621da4ccb8d42015c30de9c32","lastModifiedDate":1641891193204,"lastAccessedDate":1641891193204,"fileCreatedDate":1637762825084,"url":"https://jaws-sit-dl.tejdrive.com/download/files/04cd1bd6476d42af86e020ecf699369f","isPanoramic":"N","displayName":"Word","hash":"3824761b61b0264afa0c78754a8445e4","isInheritedShare":false,"createdBy":"cdbd05c621da4ccb8d42015c30de9c32","createdDate":1637762825084,"lastUpdatedDate":1641891193204,"status":"A"
      // }).subscribe((item) => {
      // });

    }

    async getByIndex (storeName, indexName, key) {
      return new Promise((resolve, reject) => {
        this.db.getByIndex(storeName, indexName, key).subscribe((object) => {
          if(object != undefined) {
            resolve(object);
          } else {
            reject(false);
          }
        }, error => {
          resolve(error);
        });
      });
    }

    getStoreDataCount(storeName){
      return new Promise((resolve, reject) => {
        this.db.count(storeName).subscribe((result) => {
          if(result.length != 0) {
            resolve(result);
          } else {
            reject(0);
          }
        }, error => {
          //console.log('error: ', error);
          reject(0);
        });
      })
    }

    deleteByKey(storeName,key){
      return new Promise((resolve, reject) => {
        this.db.deleteByKey(storeName,key).subscribe((deleteStatus) => {
            resolve(deleteStatus);
        }, error => {
          // console.log('error: ', error);
          resolve(false);
        });
      })
    }


    // responsible for updating the db
    public updateDBStores() {

    }
    
    public saveMetadataInDB(store, files) {
        var db = this.db;

        files.forEach(function (file) {
            db.add(store, {
              parentObjectKey: file.parentObjectKey,
              parentObjectType: file.parentObjectType,
              parentObjectId: file.parentObjectId,
              objectKey: file.objectKey,
              objectType: file.objectType,
              objectName: file.objectName,
              mimeType: file.mimeType,
              mimeSubType: file.mimeSubType,
              sizeInBytes: file.sizeInBytes,
              isHidden: file.isHidden,
              isLocked: file.isLocked,
              isReadonly: file.isReadonly,
              isRestricted: file.isRestricted,
              version: file.version,
              isFavorite: file.isFavorite,
              sourceName: file.sourceName,
              objectOwnerUserId: file.objectOwnerUserId,
              lastModifiedDate: file.lastModifiedDate,
              lastAccessedDate: file.lastAccessedDate,
              fileCreatedDate: file.fileCreatedDate,
              url: file.url,
              imageTranscodeUrl: file.imageTranscodeUrl,
              isBoardFile: file.isBoardFile,
              objectShareBy: file.objectShareBy,
              isPanoramic: file.isPanoramic,
              displayName: file.displayName,
              hash: file.hash,
              shareKey: file.shareKey,
              isInheritedShare: file.isInheritedShare,
              shareLink: file.shareLink,
              recipientsObjRights: file.recipientsObjRights,
              createdBy: file.createdBy,
              createdDate: file.createdDate,
              lastUpdatedDate: file.lastUpdatedDate,
              status: file.status,
              shareType: file.shareType,
              isShared: file.isShared,
              playbackUrl: file.playbackUrl,
              documentUrl: file.documentUrl
            })
            .subscribe((files) => {
              console.log('files key: ', files);
            });
        });

        return files;
    }

    public updateMetadataInDB(id, file) {
      var db = this.db;

      return new Promise((resolve, reject) => {
        const fileData = {
          parentObjectKey: file.parentObjectKey,
          parentObjectType: file.parentObjectType,
          parentObjectId: file.parentObjectId,
          objectKey: file.objectKey,
          objectType: file.objectType,
          objectName: file.objectName,
          mimeType: file.mimeType,
          mimeSubType: file.mimeSubType,
          sizeInBytes: file.sizeInBytes,
          isHidden: file.isHidden,
          isLocked: file.isLocked,
          isReadonly: file.isReadonly,
          isRestricted: file.isRestricted,
          version: file.version,
          isFavorite: file.isFavorite,
          sourceName: file.sourceName,
          objectOwnerUserId: file.objectOwnerUserId,
          lastModifiedDate: file.lastModifiedDate,
          lastAccessedDate: file.lastAccessedDate,
          fileCreatedDate: file.fileCreatedDate,
          url: file.url,
          imageTranscodeUrl: file.imageTranscodeUrl,
          isBoardFile: file.isBoardFile,
          objectShareBy: file.objectShareBy,
          isPanoramic: file.isPanoramic,
          displayName: file.displayName,
          hash: file.hash,
          shareKey: file.shareKey,
          isInheritedShare: file.isInheritedShare,
          shareLink: file.shareLink,
          recipientsObjRights: file.recipientsObjRights,
          createdBy: file.createdBy,
          createdDate: file.createdDate,
          lastUpdatedDate: file.lastUpdatedDate,
          status: file.status,
          shareType: file.shareType,
          isShared: file.isShared,
          playbackUrl: file.playbackUrl,
          documentUrl: file.documentUrl
        }

        db.update('files', fileData).subscribe((id) => {
          console.log('id: ', id);
          resolve(id);
        }, error => {
          console.log('error: ', error);
          reject(error);
        });
      });
  }

    



 

  

  public fetchContactsAsc() {
    var db = this.db;
    var self = this;
    return new Promise((resolve, reject) => {
      db.getAll('ContactsStore_Asc').subscribe((result) => {
        let decryptedResult = [];
        if(result.length != 0) {
          result.forEach(e => {
            e = self.syncStorageManager.fetchData(e.val);
            e = JSON.parse(e);
            decryptedResult.push(e);
          });
          resolve(decryptedResult);
        } else {
          reject(false);
        }
      }, error => {
        console.log('error: ', error);
        reject(error);
      });
    });
  }

  public saveContactsInDBAsc(items) {
    var db = this.db;
    var self = this;
    items.forEach(function (item) {
      let temp = JSON.stringify(item);
      let val = self.syncStorageManager.convertData(temp);
      db.add('ContactsStore_Asc', {val})
      .subscribe((items) => {
      });
    });

    return items;
  }

  public fetchContactsDsc() {
    var db = this.db;
    var self = this;
    return new Promise((resolve, reject) => {
      db.getAll('ContactsStore_Dsc').subscribe((result) => {
        let decryptedResult = [];
        if(result.length != 0) {
          result.forEach(e => {
            e = self.syncStorageManager.fetchData(e.val);
            e = JSON.parse(e);
            decryptedResult.push(e);
          });
          resolve(decryptedResult);
        } else {
          reject(false);
        }
      }, error => {
        console.log('error: ', error);
        reject(error);
      });
    });
  }

  public saveContactsInDBDsc(items) {
    var db = this.db;
    var self = this;
    items.forEach(function (item) {
      let temp = JSON.stringify(item);
      let val = self.syncStorageManager.convertData(temp);
      db.add('ContactsStore_Dsc', {val})
      .subscribe((items) => {
      });
    });

    return items;
}


  public setUser(user: object) { // {'name': 'test', 'email': 'test email'}
    return this.db.add('user', user).then(
    () => {
      this.loggerService.log('user added to db');
    },
    error => {
      this.loggerService.log(error);
    });
  }

  public getUser(key: string, value: string) {
      // tslint:disable-next-line: prefer-const
      let db = this.db;
      return new Promise((resolve, reject) =>
          db.getByIndex('user', key, value).then(
            user => {
                // this.loggerService.log(user);
                resolve(user);

            },
            error => {
                // this.loggerService.log(error);
                reject(error);
            },
        ),
      );
  }

  public updateUser(user: object) { // { id: 3, name: 'name', email: 'email' }
    this.db.update('user', user).then(
      () => {
        // this.loggerService.log('user updated in db');
      },
      error => {
        // this.loggerService.log(error);
      },
    );
  }
    public clearStore(storeName: string) {
      this.db.clear(storeName).subscribe((successDeleted) => {
      },error=>{
        // console.log("clearStore err",storeName,error)
      }
      
      );
    }

    public deleteDatabase() {
      this.db.deleteDatabase().subscribe((deleted) => {
        console.log('Database deleted successfully: ', deleted);
      },error=>{
        console.log("Database deleted err",error)
      }
      
      );
      ;
    }

    public getDataFromCursor(storeName: string,lowerbound,dataLimit) {
      return new Promise((resolve, reject) => {    
        let data = [];
        let cTime= new Date().getTime();
       // console.log(" checkindexDB, cursorTest::"+dataLimit+":"+cTime/1000)    

        this.db.openCursorByIndex(storeName,"id",IDBKeyRange.lowerBound(lowerbound)).subscribe((evt) => {
       //   console.log(evt)
         // console.log('success? ',storeName, successDeleted);  IDBRequest
         var cursor = evt.target.result;// as IDBOpenDBRequest).result;
         //console.log(cursor)
        if(cursor ) { //&& data.length<dataLimit

              data.push(cursor.value);
              cursor.continue()

          } else {
            if(data.length>0){
          //    console.log(" checkindexDB executiontime cursorTest, "+dataLimit+"::"+ (new Date().getTime()-cTime)/1000) 

            //  let value = data[data.length-1]
             resolve(data);
 
            }
            else
              resolve(false);
             // console.log('Entries all displayed.');
          }
  
        },error=>{
          resolve(false);
          // console.log("cursorTest err",storeName,error)
        }
        
        );
      });

     
    }

    getByKeyRange(storeName: string,visible){
      return new Promise((resolve, reject) => {     
        this.db.getAll(storeName).subscribe((result) => {
          let endPoint = visible+100;
          if(result == undefined || result.length == 0 )
            resolve(false)
          else if(result.length >= endPoint){
              resolve(result.slice(visible,endPoint));
          }else
            resolve(result.slice(visible))
        }, error => {
          resolve(error);
        });
      });
    }
  

}
